module.exports = __webpack_public_path__ + "img/top-2-0.4023a350.jpg";